<template>
    <div class="tendency_percent_bar">

        <p v-if="hasLine" class="homeComTitle hasLine">
            <span class="titleLine"></span>
            {{ title }}
        </p>
        <p v-else class="title">{{ title }}</p>

        <div v-if="!slotmag" class="mt12">
            <p v-html="content"></p>
        </div>
        <slot v-else></slot>

        <section v-if="list.length > 0" class="_box">
            <div class="toolBox flex_box justify-content_flex-justify">
                <div class="fs12">下属机构</div>
                <div class="flex_box ">
                    <p v-for="h in heads" :key="h.key" class="flex_box align-items_center" :class="'co_' + h.key">
                        <span :class="'bg_' + h.key"></span><span class="fs10">{{ h.label }}</span>
                    </p>
                </div>
            </div>
            <div v-for="item in list" :key="item.name">
                <section class="listItem flex_box align-items_center mt6 co_666">
                    <span class="titleLabel fs13 line-clamp_1">{{ item.name }}</span>
                    <div class="barBox barBoxBg flex_box">
                        <p :style="{ width: item.negativePer + '%' }"></p>
                        <p :style="{ width: item.neutralPer + '%' }"></p>
                        <p :style="{ width: item.positivePer + '%' }"></p>
                    </div>
                </section>
                <section class="listItem flex_box">
                    <div class="barBox barBoxText flex_box co_666 text_c">
                        <p v-show="item.negativePer > 0" class="fs10"
                           :style="{ width: item.negativePer + '%', marginRight: item.negativePer < 10 ? '20px' : '' }">
                            {{ item.negativePer }}%</p>
                        <p v-show="item.neutralPer > 0" class="fs10"
                           :style="{ width: item.neutralPer + '%', marginRight: item.negativePer < 10 ? '20px' : ''  }">
                            {{ item.neutralPer }}%</p>
                        <p v-show="item.positivePer > 0" class="fs10" :style="{ width: item.positivePer + '%' }">{{
                                item.positivePer
                            }}%</p>
                    </div>
                </section>
            </div>
        </section>
        <img v-else class="noDataImg mt28" src="../../assets/img/company/noData.svg" alt="">
    </div>
</template>

<script>
import utils from "@/util/common";

export default {
    name: "TendencyPercentBar",
    props: {
        renderData: Object,
        slotmag: {
            type: Boolean,
            default: false
        },
        hasLine: Boolean
    },
    data() {
        return {
            list: [],
            heads: [],
            title: "下属企业舆情分布",
            content: ""
        }
    },
    mounted() {
        this.renderFunc()
    },
    watch: {
        "renderData": function (pre, cur) {
            if (pre && cur)
                this.renderFunc()
        }
    },
    methods: {
        renderFunc() {
            let {title, content, heads, items} = this.renderData;
            this.title = title;
            this.content = content;
            this.heads = heads;
            this.list = items.filter(item => {
                let result = true;
                item.positivePer = utils.formatPercent(item.positive, item.total);
                item.neutralPer = utils.formatPercent(item.neutral, item.total);
                item.negativePer = 100 - item.positivePer - item.neutralPer;

                if (!item.negative && !item.positive && !item.neutral) {
                    result = false
                }
                return result
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.tendency_percent_bar {
    padding: 16px;

    ._box {
        margin: 28px 17px 0px 13px;

        .toolBox {
            margin-bottom: 20px;

            p {
                margin-left: 10px;

                span:first-child {
                    width: 4px;
                    height: 4px;
                    margin-right: 4px;
                    border-radius: 50%;
                }
            }
        }

        .listItem {
            width: 100%;
        }

        .titleLabel, .lastText {
            width: 38%;
        }

        .barBox {
            width: 64%;
            height: 16px;
            border-radius: 8px;

            &.barBoxBg {
                background-color: #c3d2f0;
                overflow: hidden;

                p {
                    height: 100%;

                    &:nth-child(1) {
                        background-color: #386ccf;
                    }

                    &:nth-child(2) {
                        background-color: #86a7e2;
                    }
                }
            }

            &.barBoxText {
                margin-left: 38%;
                width: 71%;
            }

            span {
                height: 100%;
            }

            .flex_1 {
                width: 0;
            }
        }

    }

}
</style>